import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import getLocal from '@/app/utils/i18n';
/**
 * 2022-01-22 k.w 自定义轮滑组件(卡片组件之No.3)
 */

const defaultStyle = {
    list: {
        listGap: 0.2, // list之间间隔
        listWidth: 2.65,
        listHeight: 4.4,
    },
};

export default function CardSliderModule({ cssStyle = defaultStyle }: any) {
    const { locale = 'us' } = getLocal();
    const styles = {
        list: { ...defaultStyle.list, ...cssStyle?.list },
    };
    const { list } = styles;
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const items1 = [
        {
            id: 1,
            icon: '/icons/mobileH5/07Icon01.svg',
            backColor: 'rgb(217, 214, 204)',
            theme: 1,
            title1: t('EV_SC'),
            title2: t('EV_SC_sub_title'),
            desc: t('EV_SC_desc'),
        },
        {
            id: 2,
            icon: '/icons/mobileH5/07Icon02.svg',
            backColor: 'rgb(255,210,108)',
            theme: 1,
            title1: t('SP_Charging'),
            title2: t('SP_Charging_sub_title'),
            desc: t('SP_Charging_desc'),
        },
        {
            id: 3,
            icon: '/icons/mobileH5/07Icon03.svg',
            backColor: 'rgb(30,30,31)',
            theme: 0,
            alt: t('wall_charge'),
            title1: '',
            title2: t('wall_charge_sub_title'),
            desc: t('wall_charge_desc'),
        },
        {
            id: 4,
            icon: '/icons/mobileH5/07Icon04.svg',
            backColor: 'rgb(2,122,255)',
            theme: 0,
            title1: t('smart_home_panel'),
            title2: t('smart_home_panel_sub_title'),
            desc: t('smart_home_panel_desc'),
        },
        {
            id: 5,
            icon: '/icons/mobileH5/07Icon05.svg',
            backColor: 'rgb(217, 214, 204)',
            theme: 1,
            title1: t('car_charging'),
            title2: t('car_charging_sub_title'),
            desc: t('car_charging_desc'),
        },
        {
            id: 6,
            icon: '/icons/mobileH5/07Icon06.svg',
            backColor: 'rgb(89,179,95)',
            theme: 1,
            title1: t('SG_charging'),
            title2: t('SG_charging_sub_title'),
            desc: t('SG_charging_desc'),
        },
    ].filter(Boolean);

    const phItems = [
        {
            id: 1,
            icon: '/icons/mobileH5/07Icon01.svg',
            backColor: 'rgb(217, 214, 204)',
            theme: 1,
            title1: t('EV_SC'),
            title2: t('EV_SC_sub_title'),
            desc: t('EV_SC_desc'),
        },
        {
            id: 2,
            icon: 'https://websiteoss.ecoflow.com/upload/image/1752460227024/Frame.png',
            backColor: 'rgb(30,30,31)',
            theme: 0,
            title1: t('SP_Charging'),
            title2: t('SP_Charging_sub_title'),
            desc: t('SP_Charging_desc'),
        },
        {
            id: 3,
            icon: '/icons/mobileH5/07Icon03.svg',
            backColor: 'rgb(255,210,108)',
            theme: 0,
            alt: t('wall_charge'),
            title1: '',
            title2: t('wall_charge_sub_title'),
            desc: t('wall_charge_desc'),
        },
        {
            id: 5,
            icon: '/icons/mobileH5/07Icon05.svg',
            backColor: 'rgb(89,179,95)',
            theme: 1,
            title1: t('car_charging'),
            title2: t('car_charging_sub_title'),
            desc: t('car_charging_desc'),
        },
    ];

    let item = items1;
    if (locale === 'ph') {
        item = phItems;
    }
    // 触屏拖拽mobile
    let originX = 0,
        startX = 0;
    const touchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0].clientX;
    };
    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0].clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= -e.currentTarget.offsetWidth + window.innerWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    return (
        <div
            className={`${css.cardSliderModule} cardSliderModule GtmModuleData-section`}
            data-section-id={css.cardSliderModule}
            data-section-title={t('EV_SC_sub_title')}
        >
            <div className="cardSliderWrapper" style={{ height: `${list.listHeight}rem` }}>
                <div className="sliderContent" style={{ height: `${list.listHeight}rem` }}>
                    <ul className="listBox" onTouchMove={touchMove} onTouchStart={touchStart}>
                        {item.map((item: any, k: number) => (
                            <li
                                className="list"
                                key={k}
                                style={{
                                    marginLeft: k === 0 ? 0 : `${parseFloat(list.listGap)}rem`,
                                    width: `${list.listWidth}rem`,
                                    height: `${list.listHeight}rem`,
                                    background: item.backColor,
                                }}
                            >
                                <div className="iconBox">
                                    <Image src={item.icon} layout="fill" className="fullImgs" alt={item.title1 !== '' ? item.title1 : t(item.alt)} />
                                </div>
                                <div className="textContent" style={{ color: item.theme ? 'rgb(3,6,11)' : '#fff' }}>
                                    <p className="guide">{item.title1}</p>
                                    <p className="title">{item.title2}</p>
                                    <p className="desc">{item.desc}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
